import {SSO_DOMAIN_URL, SSO_CLIENT_ID, GIGYA_API_KEY, SSO_API_KEY, SSO_REDIRECT_URL} from "modules/constants";

export abstract class SSOUtils {
	static REDIRECT_URL = SSO_REDIRECT_URL || `${window.location.origin}`;

	static OIDC_LOGIN_BUTTON = () => {
		const url = this.BUILD_OIDC_LOGIN_URL();

		console.log(url);
		const a = document.createElement("a");
		document.body.appendChild(a);
		a.href = url.toString();
		a.click();
		a.remove();
	};

	static BUILD_OIDC_LOGIN_URL = (): URL => {
		const SSO_REDIRECT_URL = this.REDIRECT_URL;

		const fields = [SSO_DOMAIN_URL, SSO_CLIENT_ID, GIGYA_API_KEY, SSO_REDIRECT_URL];

		if (fields.some((field) => !field)) {
			throw new Error(
				"One or more of the following fields are empty: SSO_DOMAIN_URL, SSO_CLIENT_ID, GIGYA_API_KEY, SSO_REDIRECT_URL"
			);
		}

		const generateNonce = (length = 32) =>
			window.crypto?.getRandomValues
				? Array.from(window.crypto.getRandomValues(new Uint8Array(length)))
						.map((b) => b.toString(16).padStart(2, "0"))
						.join("")
				: Math.random().toString(36).substring(2) + Date.now().toString(36);

		const nonce = generateNonce();

		const url = new URL(`${SSO_DOMAIN_URL}/oidc/op/v1.0/${SSO_API_KEY}/authorize`);

		url.searchParams.append("client_id", SSO_CLIENT_ID);
		url.searchParams.append("gig_apiKey", GIGYA_API_KEY);
		url.searchParams.append("response_type", "code");
		url.searchParams.append("prompt", "login");
		url.searchParams.append("scope", "openid profile email api nfl_complete offline_access");
		url.searchParams.append("nonce", nonce);
		url.searchParams.append("redirect_uri", SSO_REDIRECT_URL);
		url.searchParams.append("adobe_mc", window._satellite?.getVisitorId?.().getMarketingCloudVisitorID?.() || "");
		url.searchParams.append("consent_config", window.OptanonActiveGroups);

		return url;
	};
}
